import { useParams } from "react-router-dom";

import { VacancyDetailPageContent } from "./VacancyDetailPageContent";

import { VacancyDetailProvider } from "@/lib/contexts/Vacancy/VacancyDetailProvider";

const VacancyDetailPage = () => {
  const { clientId, vacancyId } = useParams();
  if (!vacancyId) throw new Error("Vacancy ID is required");
  return (
    <VacancyDetailProvider clientId={clientId} vacancyId={vacancyId}>
      <VacancyDetailPageContent clientId={clientId} vacancyId={vacancyId} />
    </VacancyDetailProvider>
  );
};

export default VacancyDetailPage;
